document.addEventListener( 'DOMContentLoaded', () => {
	const rangeInputContainers = document.querySelectorAll( [ '.range-input-container', '.ginput_container_checkbox' ] );
	if ( rangeInputContainers ) {

		rangeInputContainers.forEach( ( container, index ) => {
			const inputContainerHolder = container.closest( '.gfield' );
			const containerLabel = inputContainerHolder.querySelector( 'label' );
			const containerLabelText = containerLabel.textContent;
			containerLabel.innerHTML = `<span class="fw7">${index + 1}.</span> ${containerLabelText}`;
		} );

		const submitButton = document.querySelector( '[id^="gform_submit_button"]' );

		if ( submitButton ) {
			submitButton.classList.add( 'site-link' );
			if ( ! submitButton.querySelector( '.mw2' ) ) {
				const buttonIcon = document.createElement( 'span' );
				buttonIcon.classList.add( 'mw2' );
				const icon = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30.015 24.588"><path d="M12.354,24.588a.885.885,0,0,1-.626-1.51L22.512,12.294,11.728,1.511A.885.885,0,1,1,12.98.259L25.015,12.294,12.98,24.329A.881.881,0,0,1,12.354,24.588Z" fill="currentColor"></path><path d="M6.787,19.021a.885.885,0,0,1-.626-1.511l5.216-5.216L6.161,7.078A.885.885,0,0,1,7.412,5.827l6.468,6.467L7.412,18.762A.885.885,0,0,1,6.787,19.021Z" fill="currentColor"></path><circle cx="1.298" cy="12.294" r="1.298" fill="currentColor"></circle></svg>';
				buttonIcon.innerHTML = icon;
				submitButton.appendChild( buttonIcon );
			}
		}

	}
} );
